var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B6B6AC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.6,8.9l-8.3,6.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.4-0.4-0.4-0.6V11 c-8.9,0-12.8,2.5-12.2,10.5C3.1,8.7,10.4,5.8,19.1,5.8v-4c0-0.3,0.2-0.5,0.4-0.6c0.3-0.1,0.6,0,0.8,0.2l8.3,6.5 C28.9,8.2,28.9,8.6,28.6,8.9z M23.6,24.6c0,1.2-1,2.1-2.1,2.1h-16c-1.2,0-2.1-1-2.1-2.1v-16c0-1.2,1-2.1,2.1-2.1l2.5,0l3.2-2.1H5.4 c-2.4,0-4.3,1.9-4.3,4.3v16c0,2.3,1.9,4.3,4.3,4.3h16c2.4,0,4.3-1.9,4.3-4.3V13.3l-2.1,2.1L23.6,24.6L23.6,24.6L23.6,24.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendGrey);
export default __webpack_public_path__ + "static/media/resend-grey.ac0b4e09f9fd4376b3e0a813527751ff.svg";
export { ForwardRef as ReactComponent };